var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('LeftNavBar',{attrs:{"title":_vm.selectedAppInitial,"drag":false,"hasChild":false,"items":_vm.sidebarItems,"selectedValue":_vm.emailType},on:{"opened":_vm.selectEmailType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }